import React from "react";
import { useSelector } from "react-redux";

export default function MemberList(props) {
  const CurrentUser = useSelector((state) => state?.main?.currentUser);
  return (
    <div className="MemberListSection">
      <div className="MemberListSection__GroupName">
        <span>نام گروه:</span>
        <strong>{props.groupName}</strong>
      </div>
      <div className="MemberListSection__Table">
        <table>
          <thead>
            <tr>
              <th>ردیف</th>
              <th>نام و نام خانوادگی</th>
              <th>نقش</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{1}</td>
              <td>{CurrentUser.name}</td>
              {/* <td>{item.role}</td> */}
            </tr>
            {props.memberList.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{index + 2}</td>
                  <td>{item.name}</td>
                  <td>{item.role}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
